<template>
  <div class="py-5 container-fluid">
    <div id="topinfo">
      <div class="row mt-4 justify-content-center">
        <div class="col-12">
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur">
            <div class="card-header mb-0 text-center">
              <h3 class="font-weight-bolder text-success text-gradient">Steelcase</h3>
              <h5 class="mb-0">
                Line <i>{{ coating_booth.name }}</i>
              </h5>
            </div>
          </div>
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 card card-body blur shadow-blur">
            <div class="row text-center justify-content-center my-4">
              <div class="col-md-4 col-sm-12 mb-3 d-flex justify-content-center">
                <button
                  class="action-button"
                  @click="handleClickToBagging"
                >
                  <div class="icon-container">
                    <gun-svg
                      :fill-color="'#66758E'"
                      class="icon-svg"
                      style="width: 90%; height: 90%; scale: 3"
                    />
                  </div>
                  <span class="label">Bagging</span>
                </button>
              </div>
              <div class="col-md-4 col-sm-12 mb-3 d-flex justify-content-center">
                <button
                  class="action-button"
                  @click="handleClickToDiameterMeasurement"
                >
                  <div class="icon-container">
                    <i class="far fa-circle icon"></i>
                  </div>
                  <span class="label">Measure Diameters</span>
                </button>
              </div>
              <div class="col-md-4 col-sm-12 mb-3 d-flex justify-content-center">
                <button
                  class="action-button"
                  @click="handleClickToThicknessAdjustment"
                >
                  <div class="icon-container">
                    <i class="fa fa-bars fa-3x icon"></i>
                  </div>
                  <span class="label">Thickness Adjustment</span>
                </button>
              </div>
            </div>
            <hr class="horizontal dark" />
            <div class="row text-center justify-content-center my-4">
              <div class="col-md-4 col-sm-12 mb-3 d-flex justify-content-center">
                <button
                  class="action-button"
                  @click="handleClickToViewRecipes"
                >
                  <div class="icon-container">
                    <i class="fas fa-book icon"></i>
                  </div>
                  <span class="label">View Recipes</span>
                </button>
              </div>
              <div class="col-md-4 col-sm-12 mb-3 d-flex justify-content-center">
                <button
                  class="action-button"
                  @click="handleClickToMaintenance"
                >
                  <div class="icon-container">
                    <i class="fas fa-wrench icon"></i>
                  </div>
                  <span class="label">Maintenance</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GunSvg from "@/components/GunSvg.vue";
import setTooltip from "@/assets/js/tooltip.js";

export default {
  name: "SteelCaseDashboard",
  components: {
    GunSvg,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;

    return {
      coating_booth: {
        name: "",
      },
    };
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    setTooltip();
    document.addEventListener("click", this.closeDropdown);
    this.getData();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    document.removeEventListener("click", this.closeDropdown);
  },
  methods: {
    async getData() {
      await this.getCoatingBooths();
    },
    async getCoatingBooths() {
      try {
        const response = await axios.get("api/v1/steelcase/coatingbooth/" + this.lineId + "/");
        this.coating_booth = response.data;
        this.$store.state.isLoading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async handleClickToDiameterMeasurement() {
      try {
        let response = await axios.post("/api/v1/steelcase/tempventuridiametermeasurement/", {});
        this.diameterMeasurementId = response.data.id;
      } catch (error) {
        console.error(error);
      }
      this.$router.push({
        name: "DiameterMeasurement",
        params: {
          lineId: this.lineId,
          diameterMeasurementId: this.diameterMeasurementId
        },
      });
    },
    async handleClickToBagging() {
      try {
        let response = await axios.post("/api/v1/steelcase/temppowderoutputmeasurement/", {});
        this.powderOutputMeasurementId = response.data.id;
      } catch (error) {
        console.error(error);
      }
      this.$router.push({
        name: "Bagging",
        params: { lineId: this.lineId, powderOutputMeasurementId: this.powderOutputMeasurementId },
      });
    },
    async handleClickToThicknessAdjustment() {
      this.$router.push({
        name: "ThicknessAdjustmentSteelcase",
        params: { lineId: this.lineId },
      });
    },
    async handleClickToViewRecipes() {
      this.$router.push({
        name: "ViewRecipes",
        params: { lineId: this.lineId },
      });
    },
    async handleClickToMaintenance() {
      this.$router.push({
        name: "MaintenanceSteelcase",
        params: { lineId: this.lineId },
      });
    },
  },
};
</script>
<style scoped>
.container-fluid {
  padding-top: 20px;
}

.action-button {
  background-color: #f1f1f1;
  border: none;
  border-radius: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  width: 12rem;
  height: 8rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition:
    box-shadow 0.2s,
    transform 0.2s;
}

.action-button:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.icon-container {
  height: 3rem;
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.icon {
  font-size: 2.5rem;
  color: #66758e;
}

.icon-svg {
  width: 2.5rem;
  height: 2.5rem;
}

.label {
  font-size: 0.9rem;
  text-align: center;
  white-space: nowrap;
}
</style>
